export default {
	coinName:'书币',
	webName:'经致文学',
	telephone:'',
	qq:1367132250,
	showZFBInWeiXin:true, //是否在微信环境内展示支付宝支付
	hasMembers:true,  //是否开启会员,
	rechargeUrl:'/recharge.html',  //充值页绝对路径
	appid:'wx731c0838e6b6bea8',     //公众号id
	weixinNotFunChapterLimit:9,    //非微信粉丝限制浏览的章节
	isWeixinFunLimit:false,    //是否开启非微信粉丝章节限制
	qrCodeUrl:'http://m.jingzhi5.com/imagedata/2018/02/12/5a819b496fee9863502190.jpg',    //二维码链接
}



// WEBPACK FOOTER //
// ./src/common/config.js